import { Chip, Theme, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { AgencyCode, getWspLabel } from "../../../reducers/states/agency";

const useStyles = makeStyles((theme: Theme) => ({
  chipWSP: {
    backgroundColor: theme.agency.WSP,
    color: "white",
  },
  chipKCM: {
    backgroundColor: theme.agency.KCM,
    color: "white",
  },
  chipSFD: {
    backgroundColor: theme.agency.SFD,
    color: "white",
  },
  chipSPD: {
    backgroundColor: theme.agency.SPD,
    color: "white",
  },
  chipNeutral: {
    backgroundColor: theme.agency.Neutral,
    color: "black",
  },
  chipClosed: {
    backgroundColor: theme.marker.ClosedDispatchEventIFD,
    color: "white",
  },
  listItem: {
    flex: "1 1 55%",
  },
  removeButton: {
    color: theme.agency.SFD,
    padding: "3px",
    "margin-left": "10px",
  },
}));

interface ChipProps {
  props: {
    agency: string;
    area?: string;
    region?: string;
    isClosed?: boolean;
  };
}

export const AgencyChip = ({ props }: ChipProps) => {
  const classes = useStyles();

  const createChip = (label: string, className: string, tooltip?: string) => {
    return (
      <Tooltip title={tooltip}>
        <Chip label={label} className={props.isClosed ? classes.chipClosed : className} sx={{ minWidth: "54px" }}/>
      </Tooltip>
    )
  }

  if (props.agency === "") {
    return <div>{props.agency}</div>;
  }

  // todo: jcavner: refactor to use GetAgency function after Agencies/JOGs code branch is merged. E.g., GetAgency(AgencyCode.SPD)?.name
  switch (props.agency) {
    case AgencyCode.WSP:
      return createChip(AgencyCode.WSP, classes.chipWSP, "Washington State Patrol, " + getWspLabel(props.area) as string);
    case AgencyCode.KCM:
      return createChip(AgencyCode.KCM, classes.chipKCM, "King County Metro");
    case AgencyCode.SFD:
      return createChip(AgencyCode.SFD, classes.chipSFD, "Seattle Fire Department");
    case AgencyCode.SPD:
      return createChip(AgencyCode.SPD, classes.chipSPD, "Seattle Police Department");
    default:
      return createChip(props.agency, classes.chipNeutral);
  }
};
